import React, { useState } from 'react';
import { CreditCard, AccountBalance } from '@mui/icons-material';
import { Stack, ToggleGroup } from 'library/ui';
import { AddBankAccountForm } from './AddBankAccountForm';
import { AddCardForm } from './AddCardForm';
import { PaymentMethod, PaymentProduct } from './types';

type SupportedKind = 'card' | 'bank';

interface AddPaymentMethodProps {
    allowedKinds?: SupportedKind[];
    onSuccess: (method: PaymentMethod) => void;
    onCancel?: () => void;
    submitLabel?: string;
    cancelLabel?: string;
    product?: PaymentProduct;
}

export function AddPaymentMethod({
    allowedKinds = ['card', 'bank'],
    onSuccess,
    onCancel,
    submitLabel,
    cancelLabel,
    product = 'subs',
}: AddPaymentMethodProps) {
    const [kind, setKind] = useState<SupportedKind>(allowedKinds[0]);
    const showKindToggle = allowedKinds.length > 1;

    return (
        <Stack gap="md">
            {showKindToggle && (
                <ToggleGroup
                    options={[
                        ...(allowedKinds.includes('card')
                            ? [{ value: 'card', label: 'Credit Card', icon: CreditCard }]
                            : []),
                        ...(allowedKinds.includes('bank')
                            ? [{ value: 'bank', label: 'Bank Account', icon: AccountBalance }]
                            : []),
                    ]}
                    value={kind}
                    onChange={(v) => setKind(v as SupportedKind)}
                />
            )}
            {kind === 'card' && (
                <AddCardForm
                    onSuccess={onSuccess}
                    onCancel={onCancel}
                    submitLabel={submitLabel}
                    cancelLabel={cancelLabel}
                    product={product}
                />
            )}
            {kind === 'bank' && (
                <AddBankAccountForm
                    onSuccess={onSuccess}
                    onCancel={onCancel}
                    cancelLabel={cancelLabel}
                    product={product}
                />
            )}
        </Stack>
    );
}
